import {
  SET_LOADING, 
  GET_STAFF_ARCHIVE, GET_STAFF_ARCHIVE_ERROR,
  GET_MATERIAL_ARCHIVE, GET_MATERIAL_ARCHIVE_ERROR,
  DELETE_PROCEDURE_MATERIAL_CALUCATION, DELETE_PROCEDURE_MATERIAL_CALUCATION_ERROR,
  DELETE_PROCEDURE_STAFF_CALUCATION, DELETE_PROCEDURE_STAFF_CALUCATION_ERROR,
  GET_PROCEDURE_ARCHIVE, GET_PROCEDURE_ARCHIVE_ERROR,
  GET_OPKS, GET_PROCEDURE, GET_OPKS_ERROR, GET_PROCEDURE_ERROR,
  GET_PROCEDURE_FOR_PRICING, GET_PROCEDURE_FOR_PRICING_ERROR,
  GET_PROCEDURE_STAFF_CALUCATION, GET_PROCEDURE_STAFF_CALUCATION_ERROR,
  GET_PROCEDURE_MATERIAL_CALUCATION, GET_PROCEDURE_MATERIAL_CALUCATION_ERROR,
  CLEAR_PROCEDURE_STAFF_CALUCATION,
  CLEAR_PROCEDURE_MATERIAL_CALUCATION,
  EDIT_PROCEDURE_MATERIAL_CALUCATION, EDIT_PROCEDURE_MATERIAL_CALUCATION_ERROR,
  GET_AVAILABLE_MATERIALS, GET_AVAILABLE_MATERIALS_ERROR,
  GET_AVAILABLE_STAFF, GET_AVAILABLE_STAFF_ERROR,
  POST_PROCEDURE_MATERIAL_CALUCATION,
  EDIT_PROCEDURE_STAFF_CALUCATION, EDIT_PROCEDURE_STAFF_CALUCATION_ERROR,
  POST_PROCEDURE_STAFF_CALUCATION,  POST_PROCEDURE_STAFF_CALUCATION_ERROR,
  GET_PROCEDURES_SUMMARY,  GET_PROCEDURES_SUMMARY_ERROR,
  EDIT_ARCHIVE_MATERIAL, EDIT_ARCHIVE_PERSONEL, EDIT_ARCHIVE_LOADING, EDIT_ARCHIVE_FAIL
} from "../actions/actions";
import {EDIT_PROCEDURA_SUCCESS, EDIT_PROCEDURA_FAIL, EDIT_PROCEDURA_SET_LOADING} from "../actions/types"

const initialState = {
  opk_list: {},
  procedures_list: {},
  error: null,
  procedure_staff: [],
  procedure_material: [],
  available_staff: [],
  available_material: [],
  procedure_summary: [],
  staff_archive: {},
  material_archive: {},
  procedure_archive:{},
  archive_loading: false,
  edit_proc_loading:false,

};
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OPKS:
      return {
        ...state,
        opk_list: action.payload,
      };
    case GET_PROCEDURE_FOR_PRICING:
      return {
        ...state,
        procedures_list: action.payload,
      };
    case GET_PROCEDURE_STAFF_CALUCATION:
      return {
        ...state,
        procedure_staff: action.payload,
      };
    case GET_PROCEDURE_MATERIAL_CALUCATION:
      return {
        ...state,
        procedure_material: action.payload,
      };
    case CLEAR_PROCEDURE_MATERIAL_CALUCATION:
      return {
        ...state,
        procedure_material: [],
      };
    case CLEAR_PROCEDURE_STAFF_CALUCATION:
      return {
        ...state,
        procedure_staff: [],
      };
    case EDIT_PROCEDURE_MATERIAL_CALUCATION:
      return {
        ...state,
        procedure_material: [
          ...state.procedure_material.map((x) => {
            if (x.id == action.payload.id) {
              return action.payload;
            } else return x;
          }),
        ],
      };
    case DELETE_PROCEDURE_MATERIAL_CALUCATION:
      return {
        ...state,
        procedure_material: [
          ...state.procedure_material.filter((x) => x.id !== action.payload),
        ],
      };
    case POST_PROCEDURE_MATERIAL_CALUCATION:
      return {
        ...state,
        procedure_material: [action.payload, ...state.procedure_material],
      };
    case GET_AVAILABLE_MATERIALS:
      return {
        ...state,
        available_material: action.payload,
      };
    case GET_AVAILABLE_STAFF:
      return {
        ...state,
        available_staff: action.payload,
      };
    case EDIT_PROCEDURE_STAFF_CALUCATION:
      return {
        ...state,
        procedure_staff: [
          ...state.procedure_staff.map((x) => {
            if (x.id == action.payload.id) {
              return action.payload;
            } else return x;
          }),
        ],
      };
   case DELETE_PROCEDURE_STAFF_CALUCATION:
      return {
        ...state,
        procedure_staff: [
          ...state.procedure_staff.filter((x) => x.id !== action.payload)
        ],
      };
    case POST_PROCEDURE_STAFF_CALUCATION:
      return {
        ...state,
        procedure_staff: [action.payload, ...state.procedure_staff],
      };

    case GET_PROCEDURES_SUMMARY:
      return {
        ...state,
        procedure_summary: action.payload,
      };
    case GET_STAFF_ARCHIVE:
      return {
        ...state,
        staff_archive: action.payload,
      };
    case GET_MATERIAL_ARCHIVE:
      return {
        ...state,
        material_archive: action.payload,
      };
    case GET_PROCEDURE_ARCHIVE:
      return {
        ...state,
        procedure_archive: action.payload,
      };
    case EDIT_ARCHIVE_MATERIAL:
      return {
        ...state,
        archive_loading: false,
        material_archive: [
          ...state.material_archive.map((x) => {
            if (x.id == action.payload.id) {
              return action.payload;
            } else return x;
          }),
        ],
      }
    case EDIT_ARCHIVE_PERSONEL:
      return {
        ...state,
        archive_loading: false,
        staff_archive: [
          ...state.staff_archive.map((x) => {
            if (x.id == action.payload.id) {
              return action.payload;
            } else return x;
          }),
        ],
      }
   case EDIT_ARCHIVE_LOADING:
      return {
        ...state,
        archive_loading: true
      } 
    case EDIT_ARCHIVE_FAIL:
      return {
        ...state,
        archive_loading: false,
        error: action.payload,
      }
      ///edit procedura
      case EDIT_PROCEDURA_SUCCESS:
        let temp = state.procedure_summary 
        if(action.flag){
          let id = state.procedure_summary.findIndex(elem=>{return elem.id === action.payload.id })
          temp[id] = action.payload
        }
        else {
          
          temp = state.procedure_summary.filter((x) => x.id !== action.payload.id)
        }
      return {
        ...state,
        edit_proc_loading: false,
        procedure_summary: temp
        
      }
   case EDIT_PROCEDURA_SET_LOADING:
      return {
        ...state,
        edit_proc_loading: true
      } 
    case EDIT_PROCEDURA_FAIL:
      return {
        ...state,
        edit_proc_loading: false,
        error: action.payload,
      }
      //
    case GET_OPKS_ERROR:
    case GET_PROCEDURE_FOR_PRICING_ERROR:
    case GET_PROCEDURE_STAFF_CALUCATION_ERROR:
    case GET_PROCEDURE_MATERIAL_CALUCATION_ERROR:
    case EDIT_PROCEDURE_MATERIAL_CALUCATION_ERROR:
    case DELETE_PROCEDURE_MATERIAL_CALUCATION_ERROR:
    case GET_AVAILABLE_MATERIALS_ERROR:
    case GET_AVAILABLE_STAFF_ERROR:
    case EDIT_PROCEDURE_STAFF_CALUCATION_ERROR:
    case DELETE_PROCEDURE_STAFF_CALUCATION_ERROR:
    case POST_PROCEDURE_STAFF_CALUCATION_ERROR:
    case GET_PROCEDURES_SUMMARY_ERROR:
    case GET_STAFF_ARCHIVE_ERROR:
    case GET_MATERIAL_ARCHIVE_ERROR:
    case GET_PROCEDURE_ARCHIVE_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
